var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game-view"},[_c('keep-alive',[_c('router-view',{ref:"explainView"})],1),_c('ynk-game',{ref:"game"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }